(function () {
    function ensureAvailabilityContainer(card) {
        var existing = card.querySelector('.card-availability');
        if (existing) {
            return existing;
        }

        card.insertAdjacentHTML('beforeend', '<div class="card-availability"></div>');
        return card.querySelector('.card-availability');
    }

    function fetchRebuyPickupMarkup(productLink) {
        return fetch(productLink)
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var pickupEl = doc.querySelector('.itgGetPickupElement');
                return pickupEl ? pickupEl.innerHTML : '<span class="alert alert--note">Pickup info not found</span>';
            });
    }

    function hydrateRebuyCard(card) {
        var linkEl = card.querySelector('.rebuy-product-media a');
        if (!linkEl) {
            return Promise.resolve();
        }

        var productLink = linkEl.getAttribute('href');
        if (!productLink) {
            return Promise.resolve();
        }

        var availabilityContainer = ensureAvailabilityContainer(card);

        return fetchRebuyPickupMarkup(productLink)
            .then(function (markup) {
                availabilityContainer.innerHTML = markup;
            })
            .catch(function (error) {
                console.error('Fetch error:', error);
            });
    }

    function triggerAvailabilityRefresh() {
        if (typeof window.itgCheckAvailITG === 'function') {
            return window.itgCheckAvailITG();
        }

        return Promise.resolve();
    }

    function handleRebuyInit() {
        if (window.itgDisableRebuyInitHandler !== false) {
            return;
        }

        if (document.body.classList.contains('RunningItg')) {
            return;
        }

        document.body.classList.add('RunningItg');

        window.setTimeout(function () {
            var cards = Array.from(document.querySelectorAll('.rebuy-product-block'));

            if (!cards.length) {
                document.body.classList.remove('RunningItg');
                return;
            }

            Promise.allSettled(cards.map(hydrateRebuyCard))
                .then(triggerAvailabilityRefresh)
                .finally(function () {
                    document.body.classList.remove('RunningItg');
                });
        }, 200);
    }

    document.addEventListener('rebuy.init', function (_event) {
        handleRebuyInit();
    });
})();